/** @enum {string} */
export const ColorsPalette = Object.freeze({
  FIRST: '#3787BF',
  SECOND: '#3c8dbc',
  STEEL_BLUE: '#4682B4',
  DEEP_BLUE: '#03A9F4',
  LIGHT_GREEN: '#8BC34A',
  GREEN: '#008000',
  ORANGE: '#F89435',
  ORANGE_RED: '#FF4500',
  RED: '#FF0000',
  GREY: '#888',
  LIGHTER_GREY: '#efefef',
  LIGHT_GREY: '#D3D3D3',
  LIGHT_SLATE_GREY: '#778899',
  WHITE_SMOKE: '#F5F5F5',
  WHITE: '#FFFFFF',
  BLACK: '#111111',
  TRANSPARENT: 'transparent',
  FIRE_BRICK: '#B22222',
  SILVER: '#C0C0C0',
  FOREST_GREEN: '#009D2C',
  BLUE_ICON: '#3C8DBC',
  RED_ICON: '#B22222',
  LIGHT_MOSS_GREEN: '#5FA777',
  LIGHT_BLACK: '#262626',
  LIGHT_BLUE: '#ADD8E6',
  DEEP_SKY_BLUE: '#00bfff',
  WARNING_FONT: '#936e0f',
  WARNING_BORDER: '#DAA520',
  WARNING_BACKGROUND: '#DAA520',
  ERROR_FONT: '#B22222',
  ERROR_BACKGROUND: '#FFC0CB',
  ERROR_BORDER: '#B22222',
  PREMIUM: '#ffcc00',
  MANAGED: '#1E9BF0',
  VERIFIED: '#8DA2B8'
})

export const ArrayColorsPalette = Object.freeze([
  {
    name: 'DEEP PURPLE',
    value: '#E6ADE0'
  },
  {
    name: 'PASTEL BLUE',
    value: '#96E4FC'
  },
  {
    name: 'PALE LAVENDER',
    value: '#D8D7FF'
  },
  {
    name: 'SOFT AQUA',
    value: '#77BAD4'
  },
  {
    name: 'LIGHT BLUE',
    value: '#B4C6ED'
  },
  {
    name: 'SOFT PINK',
    value: '#DC89CE'
  },
  {
    name: 'PALE YELLOW',
    value: '#F8DF81'
  },
  {
    name: 'PEACH',
    value: '#FFCBA3'
  },
  {
    name: 'LIGHT MINT',
    value: '#89E594'
  },
  {
    name: 'SOFT GREEN',
    value: '#9BD0B7'
  },
  {
    name: 'PALE BLUE',
    value: '#ADD8E6'
  },
  {
    name: 'LAVENDER',
    value: '#C7A3F3'
  },
  {
    name: 'LIGHT GRAY',
    value: '#D9D9D9'
  },
  {
    name: 'SOFT PINK',
    value: '#E3AECA'
  },
  {
    name: 'LIGHT CORAL',
    value: '#F6AA90'
  },
  {
    name: 'PALE ORANGE',
    value: '#FDBB59'
  },
  {
    name: 'MEDIUM_PURPLE',
    value: '#B088DF'
  },
  {
    name: 'NEO_MINT',
    value: '#B0FBCD'
  },
  {
    name: 'POWDER_BLUE',
    value: '#BADFDA'
  },
  {
    name: 'KNOCK_DE_TURQUESA',
    value: '#BAFEFE'
  },
  {
    name: 'THISTLE',
    value: '#D5B6D5'
  },
  {
    name: 'PALE_VIOLET_RED',
    value: '#D9639D'
  },
  {
    name: 'CORAL_MELOSO',
    value: '#E77C72'
  },
  {
    name: 'SANDY_BROWN',
    value: '#EBA95B'
  },
  {
    name: 'LIGHT CORAL',
    value: '#F2687B'
  },
  {
    name: 'HOT_PINK',
    value: '#F278AB'
  },
  {
    name: 'LIGHT_PINK',
    value: '#F6B4BF'
  },
  {
    name: 'ROSA_CEREZO',
    value: '#F8879B'
  },
  {
    name: 'BRISA_VIOLETA',
    value: '#FFB6F0'
  }
])
